export function initEffects(): void {
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  if (!("IntersectionObserver" in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (reduced.matches) continue;
      // Content remains visible if scripting fails or motion is disabled.
      const animation = entry.target.animate([
        { opacity: .35, transform: "translateY(12px)" },
        { opacity: 1, transform: "none" },
      ], { duration: 450, easing: "cubic-bezier(.2,.75,.2,1)" });
      const cancel = () => { if (reduced.matches) animation.cancel(); };
      reduced.addEventListener("change", cancel);
      animation.finished.catch(() => {}).finally(() => reduced.removeEventListener("change", cancel));
    }
  }, { threshold: .1 });
  document.querySelectorAll(".article-card,.provider-card,.guide-card,.method-grid article,.principle-grid article,.metric-cards article,.guide-feature,.newsletter").forEach((item) => observer.observe(item));
}
